import React from "react";
import clsx from "clsx";
import AssessmentCheckupSuccess from "../AssessmentCheckupSuccess/AssessmentCheckupSuccess";
import LearningPlanExamSuccessScoreUnreleased from "../LearningPlans/LearningPlanExamSuccessScoreUnreleased";
import LearningPlanExamSuccessPreTest from "../LearningPlans/LearningPlanExamSuccessPreTest";
import LearningPlanExamSuccessPostTest from "../LearningPlans/LearningPlanExamSuccessPostTest";
import Question from "./Question";
import Message from "./questions/Message";
import Likert from "./questions/Likert";
import Rating from "./questions/Rating";
import Comments from "./questions/Comments";
import MultipleChoice from "./questions/MultipleChoice";
import Selectbox from "../FormElements/Selectbox";
import I18n from "i18n-js";

export default class Assessment extends React.Component {
  constructor(props) {
    super(props);

    this.bodyRef = React.createRef();
    this.wrapperRef = React.createRef();
    this.assessmentRef = React.createRef();

    this.successPageComponents = {
      AssessmentCheckupSuccess: AssessmentCheckupSuccess,
      LearningPlanExamSuccessScoreUnreleased:
        LearningPlanExamSuccessScoreUnreleased,
      LearningPlanExamSuccessPreTest: LearningPlanExamSuccessPreTest,
      LearningPlanExamSuccessPostTest: LearningPlanExamSuccessPostTest,
    };

    if (!this.props.sections) {
      return;
    }

    // singlePage hack for checkup (for now)
    for (var i = 0, ilen = this.props.sections.length; i < ilen; i++) {
      this.props.sections[i].singlePage = false;
    }

    const respondedElementIndex =
      this.props.progress && this.props.progress.respondedElementIndex
        ? this.props.progress.respondedElementIndex
        : 0;
    var assessmentProgress = this.getProgressItem("ASSESSMENT");

    this.state = {
      completedAssessmentError: false,
      overall_status: assessmentProgress
        ? assessmentProgress.status
        : "NOT_STARTED",
      entries: this.props.entries || [],
      elements: this.getElements(),
      respondedElementIndex: respondedElementIndex,
      prevRespondedElementIndex: respondedElementIndex - 1,
      currentSectionIndex: this.getCurrentSectionIndex(respondedElementIndex),
      loading: false,
      loadCompletedAssessmentTimeout: 1,
      completedAssessment: null,
      responseInProgressCount: 0,
      saveStatus: "idle",
    };

    this.onChange = this.onChange.bind(this);
    this.onNext = this.onNext.bind(this);
    this.onPrev = this.onPrev.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onRespond = this.onRespond.bind(this);
    this._onRespond = this._onRespond.bind(this);
    this.advanceToElement = this.advanceToElement.bind(this);
    this.sizeContextualModal = this.sizeContextualModal.bind(this);
  }

  componentDidMount() {
    window.onRespond = this._onRespond;

    if (this.props.display_mode === "contextual") {
      // size height of modal
      this.sizeContextualModal();
      $(window).on(
        "resize.assessmentContextualModal",
        this.sizeContextualModal
      );
    }
  }

  componentWillUnmount() {
    $(window).off("resize.assessmentContextualModal");
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentSectionIndex !== this.state.currentSectionIndex) {
      $(".AssessmentBody").scrollTop(0); // scroll to top after section change
    }
  }

  /**
   * Render functions
   */

  render() {
    if (!this.props.sections) {
      return null;
    }

    var assessmentWrapperClasses = clsx({
      AssessmentWrapper: true,
      Visible: this.props.visible,
      Contextual: this.props.display_mode === "contextual",
    });

    if (this.state.completedAssessmentError) {
      return (
        <div className={assessmentWrapperClasses}>
          <div className="AssessmentHeader">
            {this.props.hideButtons === true ? (
              ""
            ) : (
              <div className="AssessmentExit" onClick={this.props.onHide}>
                <span className="arrow-left" /> Exit
              </div>
            )}
            {this.renderAssessmentTitles()}
          </div>
          <div className="AssessmentBody">
            <div
              style={{
                maxWidth: "440px",
                height: "100%",
                alignSelf: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                textAlign: "center",
                margin: "0 auto",
              }}
            >
              <h2>Sorry it Seems Something is Missing</h2>
              <p>
                Somehow an error was encountered while we were recording your
                responses to the questions. Along the way something got lost
                unfortunately. Please do the following to help resolve this
                issue.
              </p>
              <ul>
                <li style={{ listStylePosition: "inside" }}>
                  Refresh the page
                </li>
                <li style={{ listStylePosition: "inside" }}>
                  Restart the Checkup from the sidebar by clicking the "Continue
                  with Checkup" button
                </li>
                <li style={{ listStylePosition: "inside" }}>
                  Navigate to the starting Message Screen using the previous
                  button in the bottom left
                </li>
                <li style={{ listStylePosition: "inside" }}>
                  Reconfirm your answer selections by going through each answer
                  again
                </li>
              </ul>
              <p>
                We apologize for the inconvenience this issue my be causing and
                thank you for working through this with us.
              </p>
            </div>
          </div>
        </div>
      );
    } else if (this.props.display_mode === "contextual") {
      return (
        <div className={assessmentWrapperClasses} ref={this.wrapperRef}>
          <div className="AssessmentHeader">
            <div className="AssessmentTitle">{this.props.title}</div>
            {this.props.hideButtons ? null : (
              <div className="AssessmentExit" onClick={this.props.onHide}>
                &times;
              </div>
            )}
          </div>
          <div className="AssessmentBody" ref={this.bodyRef}>
            {this.state.overall_status === "COMPLETED" ? (
              this.renderSuccessPage()
            ) : (
              <div className="left-column">{this.renderAssessment()}</div>
            )}
          </div>
          <div className="AssessmentFooterButtons">
            <button
              type="button"
              className="btn btn-default"
              onClick={this.props.onHide}
            >
              Ignore
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.onSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      );
    } else {
      return (
        <div className={assessmentWrapperClasses}>
          <div className="AssessmentHeader">
            {this.props.hideButtons ? null : (
              <div className="AssessmentExit" onClick={this.props.onHide}>
                <span className="arrow-left" /> Exit
              </div>
            )}
            {this.renderAssessmentTitles()}
          </div>
          {this.state.overall_status === "COMPLETED" ? (
            <div className="AssessmentBody">{this.renderSuccessPage()}</div>
          ) : (
            <div className="AssessmentBody">
              <div
                className={
                  "left-column " +
                  (this.props.sections && this.props.sections.length > 1
                    ? "has-right-column "
                    : "no-right-column ")
                }
              >
                {this.renderAssessment()}
              </div>
              {this.props.sections && this.props.sections.length > 1 ? (
                <div className="right-column">{this.renderSections()}</div>
              ) : null}
              {this.renderNavigation()}
            </div>
          )}
        </div>
      );
    }
  }

  renderSuccessPage() {
    if (this.state.loading) {
      return (
        <div className="loadingOverlay success">
          <div
            className="text"
            style={{ marginTop: "80px", textAlign: "center" }}
          >
            Submitting your responses...
          </div>
          <div className="spinner" />
        </div>
      );
    } else if (
      this.props.success_page &&
      this.props.success_page in this.successPageComponents
    ) {
      var SuccessPageComponent =
        this.successPageComponents[this.props.success_page];
      if (this.state.completedAssessment) {
        return (
          <SuccessPageComponent
            {...this.state.completedAssessment}
            course={this.props.course}
            onHide={this.props.onHide}
            hideButtons={this.props.hideButtons}
          />
        );
      } else {
        return (
          <SuccessPageComponent
            {...this.props}
            onHide={this.props.onHide}
            hideButtons={this.props.hideButtons}
          />
        );
      }
    } else {
      return <div className="jumbotron text-center">All done. Thank you!</div>;
    }
  }

  renderAssessmentTitles() {
    if (this.props.sections && this.props.sections.length > 1) {
      var assessmentTitlesClasses = clsx({
        AssessmentTitles: true,
        WithSectionTitle: this.hasSectionTitle(),
      });

      return (
        <div className={assessmentTitlesClasses}>
          <div className="AssessmentTitle">{this.props.title}</div>
          <div className="SectionTitle">{this.getSectionTitle()}</div>
        </div>
      );
    } else {
      return null;
    }
  }

  renderAssessment() {
    var self = this;
    var currentSection = this.props.sections[this.state.currentSectionIndex];
    var questions = currentSection.elements.map((element, idx) => {
      var question = element.question;
      var questionClasses = clsx({
        Question: true,
        QuestionSlide: !currentSection.singlePage,
        QuestionActive:
          !currentSection.singlePage &&
          this.getElementIndex(element) === this.state.respondedElementIndex,
      });
      var message = element.message;
      var entry = self.getEntry(element);
      if (element.type === "MESSAGE") {
        return (
          <Question
            className={questionClasses}
            number={idx + 1}
            key={message.id + "_" + idx}
          >
            <Message onChange={this.onChange} message={message} />
            {this.renderNavigation()}
          </Question>
        );
      } else if (
        element.type === "QUESTION" &&
        element.question.type === "LIKERT"
      ) {
        return (
          <Question
            className={questionClasses}
            number={idx + 1}
            label={question.statement}
            key={question.id + "_" + idx}
          >
            <Likert
              onChange={this.onChange}
              question={question}
              answers={question.options}
              labels={question.labels}
              value={
                entry &&
                entry.value &&
                entry.value.options &&
                entry.value.options.length
                  ? entry.value.options[0].optionId || entry.value.options[0].id
                  : null
              }
            />
            {this.renderNavigation()}
          </Question>
        );
      } else if (
        element.type === "QUESTION" &&
        element.question.type === "RATING"
      ) {
        return (
          <Question
            className={questionClasses}
            number={idx + 1}
            label={question.statement}
            key={question.id + "_" + idx}
          >
            <Rating
              onChange={this.onChange}
              question={question}
              stars={question.options}
              value={
                entry &&
                entry.value &&
                entry.value.options &&
                entry.value.options.length
                  ? entry.value.options[0].optionId || entry.value.options[0].id
                  : null
              }
            />
            {this.renderNavigation()}
          </Question>
        );
      } else if (
        element.type === "QUESTION" &&
        element.question.type === "COMMENTS"
      ) {
        return (
          <Question
            className={questionClasses}
            number={idx + 1}
            label={question.statement}
            key={question.id + "_" + idx}
          >
            <Comments
              onChange={this.onChange}
              question={question}
              placeholder={question.placeholder}
              value={entry && entry.value ? entry.value.text : ""}
            />
            {this.renderNavigation()}
          </Question>
        );
      } else if (
        element.type === "QUESTION" &&
        element.question.type === "MULTIPLE_CHOICE"
      ) {
        return (
          <Question
            className={questionClasses}
            number={idx + 1}
            label={question.statement}
            key={question.id + "_" + idx}
          >
            <MultipleChoice
              onChange={this.onChange}
              question={question}
              type="radio"
              value={
                entry &&
                entry.value &&
                entry.value.options &&
                entry.value.options.length
                  ? entry.value.options[0].optionId || entry.value.options[0].id
                  : null
              }
              answers={question.options.map((option) => {
                return { label: option.statement, value: option.id };
              })}
            />
            {this.renderNavigation()}
          </Question>
        );
      } else if (
        element.type === "QUESTION" &&
        element.question.type === "SELECT"
      ) {
        return (
          <Question
            className={questionClasses}
            number={idx + 1}
            label={question.statement}
            key={question.id + "_" + idx}
          >
            <Selectbox
              onChange={(event) => {
                this.onChange("SELECT", question.id, {
                  options: [{ id: event.target.value }],
                });
              }}
              question={question}
              value={
                entry &&
                entry.value &&
                entry.value.options &&
                entry.value.options.length
                  ? entry.value.options[0].optionId || entry.value.options[0].id
                  : ""
              }
              options={question.options.map((option) => {
                return { content: option.statement, value: option.id };
              })}
            />
            {this.renderNavigation()}
          </Question>
        );
      }
    });

    return (
      <div className="Assessment" ref={this.assessmentRef}>
        {questions}
      </div>
    );
  }

  renderSections() {
    var sections = this.props.sections.map((section, idx) => {
      if (section.title) {
        return (
          <div className="Section" key={idx}>
            <div className="circle-title">
              {this.renderSectionCircle(idx)}
              <div className="title">{section.title}</div>
            </div>
            <div className="line" />
          </div>
        );
      }
    });

    return (
      <div className="AssessmentSections">
        {this.renderAssessmentTitles()}
        <div className="Sections">{sections}</div>
      </div>
    );
  }

  renderSectionCircle(idx) {
    var isSectionCompleted = this.isSectionCompleted(idx);

    var circleClasses = clsx({
      circle: true,
      active: this.state.currentSectionIndex === idx,
      completed: isSectionCompleted,
    });

    if (isSectionCompleted) {
      var icon = <div className="checkmark" />;
    } else {
      var icon = <div className="step">{idx + 1}</div>;
    }

    return <div className={circleClasses}>{icon}</div>;
  }

  renderNavigationButtons() {
    var prevBtnClasses = clsx({
      "prev-btn": true,
      "btn-disabled": !this.isPrevEnabled(),
    });

    var nextBtnClasses = clsx({
      "next-btn": true,
      "btn-disabled": !this.isNextEnabled() || this.state.saveStatus === "saving",
    });

    var isSaving = this.state.saveStatus === "saving";

    return (
      <div className="navigation-buttons-wrapper">
        <button type="button" className={prevBtnClasses} onClick={this.onPrev}>
          {I18n.t("back")}
        </button>
        <button type="button" className={nextBtnClasses} onClick={this.onNext}>
          {isSaving ? (
            <span className="save-status-indicator saving">
              <span className="save-spinner" /> Saving...
            </span>
          ) : (
            I18n.t("next")
          )}
        </button>
      </div>
    );
  }

  renderNavigation() {
    return (
      <div className="AssessmentNavigation">
        {this.renderNavigationButtons()}
        <div className="progress-bar-wrapper">
          <div
            className="current-progress"
            style={{ width: this.getProgressPercentage() }}
          />
        </div>
        <div className="progress-text">
          {
            this.getSectionCompletedElements(this.state.currentSectionIndex)
              .length
          }{" "}
          of{" "}
          {
            this.getAnswerableSectionElements(this.state.currentSectionIndex)
              .length
          }{" "}
          answered
        </div>
      </div>
    );
  }

  /**
   * Change handlers
   */

  onChange(element_type, id, payload) {
    var element = this.getElement(element_type, id);
    var entries = this.logEntry(element, payload);
    this.setState({ entries: entries });
  }

  onPrev() {
    var current_section = this.props.sections[this.state.currentSectionIndex];
    var prevIndex = this.state.respondedElementIndex - 1;

    if (current_section && current_section.singlePage) {
      var prevSectionIndex = this.state.currentSectionIndex - 1;
      if (prevSectionIndex < 0) {
        return false;
      }

      var prevIndex = 0;
      for (var i = 0, ilen = this.props.sections.length; i < ilen; i++) {
        if (i === prevSectionIndex) {
          prevIndex += 1;
          break;
        }
        prevIndex += this.props.sections[i].elements.length;
      }
    }

    if (prevIndex >= 0) {
      this.setState({
        respondedElementIndex: prevIndex,
        prevRespondedElementIndex: prevIndex + 1,
        currentSectionIndex: this.getCurrentSectionIndex(prevIndex),
      });
    }
  }

  onNext() {
    if (this.state.saveStatus === "saving") {
      return;
    }

    var current_section = this.props.sections[this.state.currentSectionIndex];
    var totalElements = this.state.elements.length;
    var elementsToRespond = [];

    if (current_section && current_section.singlePage) {
      var nextIndex = 0;
      for (var i = 0, ilen = this.props.sections.length; i < ilen; i++) {
        var section = this.props.sections[i];
        nextIndex += section.elements.length;
        if (i === this.state.currentSectionIndex) {
          break;
        }
      }
      elementsToRespond = current_section.elements;
    } else {
      var nextIndex = this.state.respondedElementIndex + 1;
      var element = this.getCurrentElement();
      elementsToRespond = [element];
    }

    var requests = this.onRespond(elementsToRespond);

    if (!requests.length) {
      this.advanceToElement(nextIndex, totalElements);
      return;
    }

    this.setState({ saveStatus: "saving" });

    $.when.apply($, requests)
      .done(
        function () {
          this.setState({ saveStatus: "idle" });
          this.advanceToElement(nextIndex, totalElements);
        }.bind(this)
      )
      .fail(
        function () {
          this.setState({ saveStatus: "idle" });
        }.bind(this)
      );
  }

  advanceToElement(nextIndex, totalElements) {
    if (totalElements === nextIndex) {
      this.onSubmit();
    } else if (nextIndex < totalElements) {
      this.setState({
        respondedElementIndex: nextIndex,
        prevRespondedElementIndex: nextIndex - 1,
        currentSectionIndex: this.getCurrentSectionIndex(nextIndex),
      });
    }
  }

  onRespond(elements) {
    var requests = [];

    for (var i = 0, ilen = elements.length; i < ilen; i++) {
      var element = elements[i];
      var entry = this.getEntry(element);
      if (
        (entry && entry.sync === true) ||
        (element && element.type === "MESSAGE")
      ) {
        if (entry && element.type === "QUESTION") {
          var payload = {
            entry_type: element.question.type,
            id: element.question.id,
            element_id: element.id,
            value:
              element.question.type === "COMMENTS"
                ? entry.value.text
                : JSON.stringify(entry.value.options),
          };
          requests.push(this._onRespond(payload));
        } else if (element.type === "MESSAGE") {
          var payload = {
            entry_type: element.type,
            id: element.message.id,
            element_id: element.id,
          };
          requests.push(this._onRespond(payload));
        }
      }
    }

    return requests;
  }

  _onRespond(payload) {
    var self = this;
    this.setState({
      responseInProgressCount: this.state.responseInProgressCount + 1,
    });

    return $.ajax({
      type: "POST",
      url: this.props.assessment_respond_path,
      data: payload,
    })
      .done(function (data) {
        if (data && data.success) {
          var entryIndex = self.findEntryIndex(payload.id);
          var { entries } = self.state;
          if (entries[entryIndex]) {
            entries[entryIndex].sync = false;
          }
          self.setState({
            entries: entries,
          });
          $(window).trigger("onRespondComplete", payload);
        }
      })
      .fail(function () {
        self.setState({ completedAssessmentError: true });
      })
      .always(function () {
        self.setState({
          responseInProgressCount: Math.max(
            self.state.responseInProgressCount - 1,
            0
          ),
        });
      });
  }

  findEntryIndex(id) {
    for (var i = 0, ilen = this.state.entries.length; i < ilen; i++) {
      if (
        this.state.entries[i].value.messageId === id ||
        this.state.entries[i].value.questionId === id
      ) {
        return i;
      }
    }
  }

  onSubmit() {
    var self = this;
    this.setState({ overall_status: "COMPLETED", loading: true }, function () {
      var submitInterval = setInterval(function () {
        if (self.state.responseInProgressCount === 0) {
          clearInterval(submitInterval);
          self.loadCompletedAssessment();
        }
      }, 1000);
    });
  }

  /**
   * Helper functions
   */

  loadCompletedAssessment() {
    var self = this;
    if (this.state.loadCompletedAssessmentTimeout < 5) {
      setTimeout(function () {
        $.ajax({
          type: "POST",
          url: self.props.get_assessment_path,
        }).done(function (data) {
          var completedAssessment = data.data;
          var completed = completedAssessment && completedAssessment.completed;
          if (completed) {
            self.setState(
              { loading: false, completedAssessment: completedAssessment },
              function () {
                $(window).trigger("onCompleteAssessment", data);
              }
            );
          } else {
            self.setState(
              {
                loading: true,
                loadCompletedAssessmentTimeout:
                  self.state.loadCompletedAssessmentTimeout * 2,
              },
              function () {
                self.loadCompletedAssessment();
              }
            );
          }
        });
      }, this.state.loadCompletedAssessmentTimeout * 1000);
    } else {
      this.setState({ completedAssessmentError: true, loading: false });
    }
  }

  getResultItem(key, assessment) {
    if (assessment && assessment.results) {
      var results = assessment.results;
      for (var i in results) {
        var result = results[i];
        if (result && result.type === key) {
          return result;
        }
      }
    }
  }

  getCurrentElement() {
    var elements = this.getElements();
    return elements[this.state.respondedElementIndex];
  }

  getCurrentElementSectionIndex() {
    var current_element = this.getCurrentElement();
    for (var i = 0, ilen = this.props.sections.length; i < ilen; i++) {
      var section = this.props.sections[i];
      for (var j = 0, jlen = section.elements.length; j < jlen; j++) {
        var element = section.elements[j];
        if (
          current_element.type === "MESSAGE" &&
          element.type === "MESSAGE" &&
          element.message.id === current_element.message.id
        ) {
          return j;
        } else if (
          current_element.type === "QUESTION" &&
          element.type === "QUESTION" &&
          element.question.id === current_element.question.id
        ) {
          return j;
        }
      }
    }
  }

  getElement(element_type, id) {
    var elements = this.getElements();

    for (var i = 0, ilen = elements.length; i < ilen; i++) {
      var element = elements[i];
      if (element.type === "QUESTION" && element.question.id === id) {
        return element;
      } else if (element.type === "MESSAGE" && element.message.id === id) {
        return element;
      }
    }

    return null;
  }

  getElementIndex(element) {
    var elements = this.getElements();
    for (var i = 0, ilen = elements.length; i < ilen; i++) {
      if (
        element.type === "QUESTION" &&
        elements[i].type === "QUESTION" &&
        element.question.id === elements[i].question.id
      ) {
        return i;
      } else if (
        element.type === "MESSAGE" &&
        elements[i].type === "MESSAGE" &&
        element.message.id === elements[i].message.id
      ) {
        return i;
      }
    }
  }

  getElements() {
    var elements = this.props.sections.map((section) => {
      return section.elements;
    });
    return [].concat.apply([], elements); // flattens array of arrays
  }

  getEntry(current_element) {
    var index = this.getEntryIndex(current_element);
    return this.state.entries[index];
  }

  getEntryIndex(current_element) {
    for (var i = 0, ilen = this.state.entries.length; i < ilen; i++) {
      if (current_element.type === "MESSAGE") {
        if (
          this.state.entries[i].value.messageId === current_element.message.id
        ) {
          return i;
        }
      } else if (current_element.type === "QUESTION") {
        if (
          this.state.entries[i].value.questionId === current_element.question.id
        ) {
          return i;
        }
      }
    }

    return -1;
  }

  getCurrentSectionIndex(respondedElementIndex) {
    var elementCount = 0;
    if (respondedElementIndex > 0) {
      for (var i = 0, ilen = this.props.sections.length; i < ilen; i++) {
        for (
          var j = 0, jlen = this.props.sections[i].elements.length;
          j < jlen;
          j++
        ) {
          if (elementCount === respondedElementIndex) {
            return i; // the section index
          }
          elementCount++;
        }
      }
    }

    return 0;
  }

  getProgressPercentage() {
    var completedElements = this.getSectionCompletedElements(
      this.state.currentSectionIndex
    ).length;
    var allElements = this.getAnswerableSectionElements(
      this.state.currentSectionIndex
    ).length;

    return parseInt((completedElements / allElements) * 100) + "%";
  }

  getSectionElements(sectionIndex) {
    var section = this.props.sections[sectionIndex];

    if (section && section.elements) {
      return section.elements;
    }

    return [];
  }

  getAnswerableSectionElements(sectionIndex) {
    var section = this.props.sections[sectionIndex];

    if (section && section.elements) {
      return section.elements.filter((element) => {
        return element.type === "QUESTION";
      });
    }

    return [];
  }

  getProgressItem(targetType) {
    if (this.props.progress && this.props.progress.items) {
      for (var i = 0, ilen = this.props.progress.items.length; i < ilen; i++) {
        var progress_item = this.props.progress.items[i];
        if (progress_item.targetType === targetType) {
          return progress_item;
        }
      }
    }
  }

  getSectionCompletedElements(sectionIndex) {
    var answerableElements = this.getAnswerableSectionElements(sectionIndex);
    var completed_elements = [];

    if (answerableElements) {
      for (var i = 0, ilen = answerableElements.length; i < ilen; i++) {
        var entry = this.getEntry(answerableElements[i]);
        if (entry) {
          completed_elements.push(answerableElements[i]);
        }
      }
    }

    return completed_elements;
  }

  getSectionTitle() {
    if (this.hasSectionTitle()) {
      return this.props.sections[this.state.currentSectionIndex].title;
    }
  }

  hasSectionTitle() {
    return (
      this.props.sections &&
      this.props.sections.length &&
      this.props.sections[0].title
    );
  }

  isSectionCompleted(sectionIndex) {
    var elements_count = this.getAnswerableSectionElements(sectionIndex).length;
    var completed_elements_count =
      this.getSectionCompletedElements(sectionIndex).length;

    return elements_count <= completed_elements_count;
  }

  isPrevEnabled() {
    if (this.state.respondedElementIndex === 0) {
      return false;
    }

    return true;
  }

  isNextEnabled() {
    var current_section = this.props.sections[this.state.currentSectionIndex];
    if (current_section && current_section.singlePage) {
      return this.isSectionCompleted(this.state.currentSectionIndex);
    } else {
      var current_element = this.getCurrentElement();
      var entry = this.getEntry(current_element);
      if (current_element) {
        var { type, validation = {} } = current_element;
        if (type === "MESSAGE" || !validation.required) {
          return true;
        } else if (validation.required && entry) {
          return true;
          // if (type === 'QUESTION' && question.type === 'LIKERT' && entry) {
          // 	console.log('LIKERT validation required')
          // 	return true
          // } else if (type === 'QUESTION' && question.type === 'MULTIPLE_CHOICE' && entry) {
          // 	return true
          // } else if (type === 'QUESTION' && question.type === 'RATING' && entry) {
          // 	return true
          // } else if (type === 'QUESTION' && question.type === 'COMMENTS' && entry) {
          // 	return true
          // }
        }
      }
    }

    return false;
  }

  logEntry(element, value) {
    var entry = null;

    if (element.type === "MESSAGE") {
      entry = {
        value: { messageId: element.message.id },
      };
    } else if (element.type === "QUESTION") {
      entry = {
        value: { questionId: element.question.id, ...value },
      };
    }

    var { entries } = this.state;
    var entryIndex = this.getEntryIndex(element);
    if (
      entryIndex !== -1 &&
      JSON.stringify(this.state.entries[entryIndex].value) ==
        JSON.stringify(entry.value)
    ) {
      entry.sync = false;
    } else {
      entry.sync = true;
    }

    if (entry) {
      if (entryIndex === -1) {
        entries.push(entry);
      } else {
        entries[entryIndex] = entry;
      }
    }

    return entries;
  }

  sizeContextualModal() {
    var $window = $(window);
    var $body = $(this.assessmentRef);
    var $wrapper = $(this.wrapperRef);
    if ($body.innerHeight() + 40 + 110 > $window.height()) {
      $wrapper.css({ bottom: "20px", "min-height": "auto" });
    } else {
      $wrapper.css({ bottom: "auto", "min-height": "420px" });
    }
  }
}
